import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'taxonomyTreeToText',
  standalone: true,
})
export class TaxonomyTreeToTextPipe implements PipeTransform {
  public transform(value: string[] | string, separator = ' > '): string {
    if (Array.isArray(value)) {
      return value.join(separator);
    }
    return value;
  }
}
